import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'rdf-block-type-selector',
  templateUrl: './block-type-selector.component.html',
  styleUrls: ['./block-type-selector.component.css']
})
export class BlockTypeSelectorComponent implements OnInit {
  @Input() type = '0';
  @Input() totals = false;
  @Output() onTypeSelected = new EventEmitter()
  @Output() onSumTotalsSelected = new EventEmitter()
  constructor() { }

  ngOnInit() {
  }

  selectBlockType(val) {
    this.onTypeSelected.emit(val.value)
  }

  setSumTotals(val) {
    this.onSumTotalsSelected.emit(val.checked)
  }
}
